import { jsx } from "react/jsx-runtime";
import { Switch } from "antd";
import classnames from "classnames";
import { rootClass } from "./constant.js";
import "./index.css";
function switch_Switch(props) {
    return /*#__PURE__*/ jsx(Switch, {
        ...props,
        className: classnames(rootClass, props.className)
    });
}
const components_switch = switch_Switch;
export { components_switch as default };
